/*
MIT LICENSE
Copyright (c) 2020-present Alibaba Cloud Design
Copied from 'antd/components/tabs/index.tsx'.
Copyright (c) 2015-present Ant UED, https://xtech.antfin.com/

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE. */
import React from 'react';
import classNames from 'classnames';
import RcTabs from 'rc-tabs';
import { ConfigContext } from '../config-provider';
import AnimationContext from '../config-provider/AnimationContext';
import warning from 'antd/lib/_util/warning';
import SizeContext from '../config-provider/SizeContext';
import { Icon } from '../icon';
import { TabPane, TabPaneProps } from './TabPane';
export const Tabs = (props) => {
    const { align, disabled, ...otherProps } = props;
    const { prefixCls: customizePrefixCls, type, className, size: propSize, editable: propsEditable, onEdit, hideAdd, centered, addIcon, moreIcon = React.createElement(Icon, { type: 'overflow-menu--horizontal', size: 'small' }) } = props;
    const { getPrefixCls, direction } = React.useContext(ConfigContext);
    const animation = React.useContext(AnimationContext);
    const prefixCls = getPrefixCls('tabs', customizePrefixCls);
    let editable;
    if (type === 'editable-card' || propsEditable === true) {
        editable = {
            onEdit: (editType, { key, event }) => {
                props.onEdit?.(editType === 'add' ? event : key, editType);
            },
            removeIcon: React.createElement(Icon, { type: 'close', size: 'small' }),
            addIcon: props.addIcon || React.createElement(Icon, { type: 'add', size: 'small' }),
            showAdd: props.hideAdd !== true
        };
    }
    const rootPrefixCls = getPrefixCls();
    if (process.env.NODE_ENV !== 'production')
        warning(!('onPrevClick' in props) && !('onNextClick' in props), 'Tabs', '`onPrevClick` and `onNextClick` has been removed. Please use `onTabScroll` instead.');
    if (!['line', 'line-simple', 'separator'].includes(type)) {
        otherProps.type = type;
    }
    // return <AntdTabs className={customClassName} {...otherProps}></AntdTabs>;
    return (React.createElement(SizeContext.Consumer, null, (contextSize) => {
        const size = propSize !== undefined ? propSize : contextSize;
        return (React.createElement(RcTabs, { direction: direction, moreTransitionName: `${rootPrefixCls}-slide-up`, ...props, className: classNames({
                [`${prefixCls}-line`]: ['line', 'line-simple', 'separator'].includes(type),
                [`${prefixCls}-line-simple`]: type === 'line-simple',
                [`${prefixCls}-separator`]: type === 'separator',
                [`${prefixCls}-full-width`]: align === 'full-width',
                [`${prefixCls}-disabled`]: disabled,
                [`${prefixCls}-${size}`]: size,
                [`${prefixCls}-card`]: ['card', 'editable-card'].includes(type),
                [`${prefixCls}-editable-card`]: type === 'editable-card',
                [`${prefixCls}-centered`]: centered,
                [`${prefixCls}-breathing-gradient`]: !!animation?.breathing
            }, className), editable: editable, moreIcon: moreIcon, prefixCls: prefixCls }));
    }));
};
Tabs.defaultProps = {
    type: 'line' // Overrider the default type 'line' in Antd Tabs.
};
Tabs.TabPane = TabPane;
// export default withConfigProvider(Tabs);
export default Tabs;
